// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Video = ((($) => {
  // try to declare variables that are going to be used to improve performance
  let playBtn;

  // in this function you get all the div elements that need to be manipulated
  function init() {
    playBtn = $('.btn-play');

    _attachEvents();
  }

  // this function attaches all the events that happen when the user interacts.
  // here is where you would also put something like window events
  function _attachEvents() {
    playBtn.click(_handleClickElement);
  }

  function _handleClickElement() {
    $('.video-item').trigger('play');
    //$(this).hide();
    $('.video-item').attr('controls', 'true');
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default Video;



// WEBPACK FOOTER //
// ./src/static/js/modules/video.js